import { StyleOptions } from './StyleOptions.js';

export enum LayerType {
  Cluster = 'Cluster',
  HeatMap = 'HeatMap',
  Ranges = 'Ranges',
  Matches = 'Matches',
  Geobubble = 'Geobubble',
  Simple = 'Simple',
  Building = 'Building',
}

export class LayerOptions {
  id: string;
  name?: string;
  style: StyleOptions;
  type: LayerType;
  hoverPopup?: boolean;
  popup?: boolean;
  afterLayer?: string;
  popupContent?: string;
  tooltipContent?: string;
  dragable?: boolean;
  maxzoom?: number;
  minzoom?: number;
  displayOnTop?: boolean;
  legend?: boolean;

  constructor(options: Partial<LayerOptions>) {
    if (!options.id) {
      throw new Error('LayerOptions.id is required');
    }
    if (!options.type) {
      throw new Error('LayerOptions.type is required');
    }
    if (!options.style) {
      throw new Error('LayerOptions.style is required');
    }

    if (options.style instanceof StyleOptions) {
      this.style = options.style;
    } else {
      this.style = new StyleOptions(options.style);
    }
    this.id = options.id;
    this.name = options.name;
    this.type = options.type;
    this.hoverPopup = options.hoverPopup;
    this.popup = options.popup;
    this.afterLayer = options.afterLayer;
    this.popupContent = options.popupContent;
    this.tooltipContent = options.tooltipContent;
    this.dragable = options.dragable;
    this.maxzoom = options.maxzoom;
    this.minzoom = options.minzoom;
    this.displayOnTop = options.displayOnTop;
    this.legend = options.legend;
  }
}
